import { render, staticRenderFns } from "./LeaveAttachmentWasAdded.vue?vue&type=template&id=a6f834b6"
import script from "./LeaveAttachmentWasAdded.vue?vue&type=script&lang=js"
export * from "./LeaveAttachmentWasAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports